import RichText from "@/components/RichText";

// Chaque colonne est un bloc générique (text_block ou image_block, voir
// theme_service.GENERIC_BLOCK_TYPES) — "multicolumn" n'a pas de blocs
// dédiés, il réutilise tel quel ce qui existe déjà depuis le Sprint 0.
export default function MulticolumnSection({ props = {}, blocks = [] }) {
  const columns = (blocks || []).filter((b) => b.enabled !== false);
  if (!columns.length) return null;

  const colsClass = columns.length >= 4 ? "md:grid-cols-4" : columns.length === 3 ? "md:grid-cols-3" : "md:grid-cols-2";

  return (
    <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-section md:py-section-md">
      {props.heading && (
        <RichText
          as="h2"
          className="font-display font-semibold text-[28px] md:text-[32px] leading-tight tracking-[-0.02em] text-ink mb-10 text-center"
          html={props.heading}
        />
      )}
      <div className={`grid sm:grid-cols-2 ${colsClass} gap-8`}>
        {columns.map((block) => (
          <div key={block.id} data-block-key={block.id} className="flex flex-col items-start">
            {block.type === "image_block" && block.props?.image_url && (
              <img src={block.props.image_url} alt={block.props?.alt || ""} className="w-full rounded-xl object-cover aspect-[4/3] mb-4" />
            )}
            {block.props?.heading && (
              <RichText as="h3" className="font-display font-semibold text-[17px] text-ink" html={block.props.heading} />
            )}
            {block.props?.body && (
              <RichText
                as="div"
                preserveParagraphs
                className="text-[14px] text-graphite mt-2 leading-relaxed [&_a]:underline [&_a]:text-gold"
                html={block.props.body}
              />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
